import { axios, axiosMiddlewareService } from '@argon/app/axios'
const giveUp = (store, router) => {
  store
    .dispatch('auth/signout')
    .then(() => {
      router.push({ path: '/signin' }).catch(() => {})
    })
    .catch(() => {})
}
const authMiddleware = (store, router) => {
  axiosMiddlewareService.register({
    onResponseError(err) {
      let accessDenied = err.status_code === 401
      let hasNotRetried = err.config && !err.config.hasRetried
      let canRefresh = store.getters['auth/hasToken'] && hasNotRetried
      let data = err.config.data ? JSON.parse(err.config.data) : undefined
      if (!accessDenied) {
        throw err
      }
      if (!canRefresh) {
        giveUp(store, router)
        throw err
      }
      err.config.hasRetried = true
      return store
        .dispatch('auth/refreshToken')
        .then(() => {
          let newConfig = { ...err.config, data }
          delete newConfig.headers
          return axios(newConfig)
        })
        .catch(() => {
          giveUp(store, router)
          throw err
        })
    }
  })
}

export default authMiddleware
